import React from 'react';
// import logo from './images/logo.svg';
import './css/App.css';
import Nav from './Nav';
import Modal from './components/Modal';
//import { PIECES } from './pieces/pieces';
import CardRow from './components/CardRow';
import LeftPane from './components/LeftPane';
// import update from 'immutability-helper';

class App extends React.Component {    


    constructor(props){
        super(props);

        this.state = {
            showModal: false,
            tokendata: '',
            qparms: ''
        };
    }

    setToken = (tokendata) => {
        this.setState(
            { tokendata: tokendata },
            () => this.toggleModal()        
        );
        // this.setState({ showModal: !this.state.showModal });
    }

    toggleModal = () => {
        this.setState({ showModal: !this.state.showModal })
    }

    handleChange = (selectedOption, selname) => {

        let qparray = []
        let qparray2 = []
        var querystring = ''
        var separator = ''
        
        // the x was clicked on a select box to remove the trait selection
        if (selectedOption == null)
        {
            // split the existing querystring parms in state into an array
            qparray = this.state.qparms.split('&')

            // loop through each trait in the querystring
            for (var i=0; i<qparray.length; i++)
            {   
                // split the querystring parm into key and value 
                qparray2 = qparray[i].split('=')
                // if the key matches the select box where an x was clicked skip adding back to the querystring - add everything else
                if (qparray2[0] !== selname)
                {
                    // console.log(selname+'-'+qparray2[0])
                    querystring += separator+qparray2[0]+'='+qparray2[1]
                    // console.log(querystring)
                    separator = '&'
                }   
            }
        }
        // a select box in leftpane was changed 
        else
        {
            //let qparray3 = []
            let updated = false

            // query parameters already exist 
            if (this.state.qparms !== '')
            {
                // split the existing querystring parms in state into an array
                qparray = this.state.qparms.split('&')

                // loop through each trait in the querystring
                for (var j=0; j<qparray.length; j++)
                {   
                    // split the querystring parm into key and value 
                    qparray2 = qparray[j].split('=')
                    // if the existing parameter key matches the changed key - update the value for the key to the changed value
                    if (qparray2[0] === selectedOption.parm)
                    {
                        // console.log('1')
                        querystring += separator+qparray2[0]+'='+selectedOption.value
                        updated = true
                    }
                    // existing parameter is not the changed parameter so add the parameter back as is
                    else
                    {
                        // console.log('2')
                        querystring += separator+qparray2[0]+'='+qparray2[1]
                    }
                    separator = '&'
                }
            }
            // querystring is currently empty or the parameter didn't exist alredy so add it
            if (!updated)
            {
                // console.log('3')
                querystring += separator+selectedOption.parm+'='+selectedOption.value       
            }
        }
        // set the new querystring into state to rerender
        //this.setState({qparms: querystring}, () => console.log(this.state.qparms))
        this.setState({qparms: querystring})
    };

    // toggleModal = (tokendata) => {
    //     console.log(tokendata);
    //     //this.setState({ showModal: !this.state.showModal })
    // }


    // modalReceive = (tokendata) => {
    //     console.log(tokendata);
    //     this.setState({ modalToken: tokendata})
    // }

    render(){
        return (
            <div className="App">
                <Nav />
                <div className="grid-container">
                    <div className="leftpane">
                        <LeftPane selchange={this.handleChange} inputchange={this.onInputChange}/>
                    </div>
                    <div className="rightpane">
                        <Modal show={this.state.showModal} piece={this.state.tokendata} toggle={this.toggleModal}/>
                        
                        <CardRow isOpen={this.state.showModal} setToken={this.setToken} qparms={this.state.qparms}/>
                    </div>
                </div>
            </div>

        );
    }
}

export default App;
